import React, { useState, useEffect } from 'react';
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ProvisioningStatusHistory({ data, selectedPage ,getprovisionHistory }) 
{
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPage] = useState(1);
    const itemsPerPage = 100

    useEffect(() => {
        if (data?.provisioningStatusList?.length > 0) {
            const uniqueData = data.provisioningStatusList.filter(
                (item, index, self) =>
                    index === self.findIndex(t => JSON.stringify(t) === JSON.stringify(item))
            );

            const sortedData = uniqueData.sort((a, b) => {
                const aDate = a.provisionRunDate ? new Date(a.provisionRunDate) : null;
                const bDate = b.provisionRunDate ? new Date(b.provisionRunDate) : null;

                if (!aDate && !bDate) return 0;
                if (!aDate) return 1;
                if (!bDate) return -1;
                return bDate - aDate;
            });

            const result = (searchTerm !== '' )
                ? sortedData.filter(item =>
                    item.deviceID?.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
                )
                : sortedData;
            const totalPages = Math.ceil(data?.count / itemsPerPage);

            if (selectedPage !== undefined && selectedPage !== currentPage)
            {
                setCurrentPage(selectedPage);
            }
            setTotalPage(totalPages);
            setFilteredData(result);
        }
    }, [data, searchTerm ,selectedPage]);
    

    const toggleRow = (index) => {
        setExpandedRows(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 10;

        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        getprovisionHistory(pageNumber, itemsPerPage);
    }

    return (
        <div className="provision-box">
            <div onClick={() => setIsOpen(!isOpen)} className="provision-box-ttl">
                <div className="provision-box-ttl-name">Provisioning history</div>
                <div className="provision-box-ttl-icon">
                    <IconButton aria-label="arrow button">
                        {isOpen ? (
                            <ExpandLessIcon className="sidebar-expand" />
                        ) : (
                            <ExpandMoreIcon className="sidebar-expand" />
                        )}
                    </IconButton>
                </div>
            </div>

            {isOpen && (
                <div className="provision-adn-open">
                    <nav aria-label="Page navigation">
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="secondary-btn btn-small" onClick={() => paginate(1)} disabled={currentPage === 1}>
                                    &lt;&lt;
                                </button>
                            </li>
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button  className="secondary-btn btn-small" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                    Previous
                                </button>
                            </li>
                            {getPageNumbers().map(number => (
                                <li key={number} >
                                    <button className={`page-item ${currentPage === number ? 'primary-btn btn-small tableSelected' : 'secondary-btn btn-small'}`} onClick={() => paginate(number)}>
                                        {number}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="secondary-btn btn-small" onClick={() => paginate(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </li>
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="secondary-btn btn-small" onClick={() => paginate(totalPages)} disabled={currentPage === totalPages}>
                                    >>
                                </button>
                            </li>
                        </ul>
                    </nav>
                    <table className="table table-striped table-bordered table-sm" aria-labelledby="tableLabel">
                        <thead>
                        <tr>
                            <th>Make</th>
                            <th>Model</th>
                            <th>DeviceId</th>
                            <th>NickName</th>
                            <th>AssetId</th>
                            <th>Organization</th>
                            <th>Install Check Date</th>
                            <th>Install Check Result</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <React.Fragment key={ index}>
                                    <tr>
                                        <td>{item?.make}</td>
                                        <td>{item?.model}</td>
                                        <td>{item?.deviceID}</td>
                                        <td>{item?.nickName}</td>
                                        <td>{item?.assetID}</td>
                                        <td>{item?.organization}</td>
                                        <td>{item?.provisionRunDate}</td>
                                        <td>{item?.result}</td>
                                        <td>
                                            <IconButton size="small" onClick={() => toggleRow(index)}>
                                                {expandedRows[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </td>
                                    </tr>
                                    {expandedRows[index] && (
                                        <tr className="accordion-row">
                                            <td colSpan="9">
                                                <div className="accordion-content">
                                                    <strong>Provisioning status</strong>
                                                    <ul>
                                                        <ul>
                                                            {item.provision ? (
                                                                JSON.parse(item.provision).map((step, idx) => (
                                                                    <ol key={idx}>
                                                                        {step.StepNumber} . {step.ProvisionStep} —{' '}
                                                                        <span className={step.Status ? 'green-class' : 'red-class'}>
                                                                           {step.Status ? 'Passed' : 'Failed'}
                                                                          </span>
                                                                    </ol>
                                                                ))
                                                            ) : (
                                                                <li>No provision data available.</li>
                                                            )}
                                                        </ul>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9">No results found.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ProvisioningStatusHistory;